import { SEARCH_ROUTES } from './searchRoutes';
import { getStoredUser } from '../../utils/authStorage';

export const SEARCH_CATEGORIES = {
  0: { route: SEARCH_ROUTES.testSeries, title: 'Test Series', icon: 'bi-ui-checks-grid' },
  1: { route: SEARCH_ROUTES.quizPyp, title: 'Tests & Quizzes', icon: 'bi-ui-checks-grid' },
  2: { route: SEARCH_ROUTES.questions, title: 'Search Question List', icon: 'bi-journal-bookmark-fill' },
  3: { route: SEARCH_ROUTES.lectures, title: 'Search Lectures', icon: 'bi-play-btn' },
  4: { route: SEARCH_ROUTES.shortNotes, title: 'Search Short Notes', icon: 'bi-book-half' },
  7: { route: SEARCH_ROUTES.exams, title: 'Exams', icon: 'bi-mortarboard' },
  8: { route: SEARCH_ROUTES.blogs, title: 'Search News & Articles', icon: 'bi-book-half' },
};

export function searchContext(location, categoryId) {
  const state = getSearchRouteState(location.pathname, location.state);
  return {
    categoryId,
    keyword: String(state.searchController ?? state.keyword ?? '').trim(),
    searchLogId: Number(state.searchLogId) || 0,
    categoryName: state.searchData?.category_name || SEARCH_CATEGORIES[categoryId]?.title || '',
    seriesId: Number(state.seriesId) || 0,
    stateId: Number(state.stateId) || 0,
    stateName: state.stateName || '',
  };
}

export function getSearchRouteState(pathname, routeState) {
  return routeState != null ? routeState : readSearchSession(`route:${pathname}`, {});
}

export function navigateSearch(navigate, pathname, state, options = {}) {
  const flow = getSearchRouteState(pathname, state);
  writeSearchSession(`route:${pathname}`, flow);
  navigate(pathname, { ...options, state: flow });
}

export function searchDetailPath(categoryId) {
  const route = { 2: SEARCH_ROUTES.questionDetail, 3: SEARCH_ROUTES.lectureDetail, 4: SEARCH_ROUTES.noteDetail, 8: SEARCH_ROUTES.articleDetail }[categoryId];
  return route;
}

export function itemId(item, categoryId) {
  return Number(item?.id || item?.[{ 0: 'series_id', 1: 'quiz_id', 2: 'question_id', 3: 'lecture_id', 4: 'note_id', 7: 'exam_id', 8: 'blog_id' }[categoryId]] || 0);
}

export function readSearchSession(key, fallback = null) {
  const user = getStoredUser();
  try { return JSON.parse(sessionStorage.getItem(`vidya-kasam:search:${user?.id || user?.user_id || 'current'}:${key}`)) || fallback; } catch (_) { return fallback; }
}

export function writeSearchSession(key, value) {
  const user = getStoredUser();
  try { sessionStorage.setItem(`vidya-kasam:search:${user?.id || user?.user_id || 'current'}:${key}`, JSON.stringify(value)); } catch (_) { /* Storage can be disabled. Navigation state remains available. */ }
}

export function addRecentSearch(recent, keyword) {
  return [keyword, ...recent.filter((item) => item.toLowerCase() !== keyword.toLowerCase())].slice(0, 5);
}

export function apiColor(value) {
  const hex = String(value || '').replace(/^#/, '').trim();
  return /^(?:[\da-f]{3}|[\da-f]{6}|[\da-f]{8})$/i.test(hex) ? `#${hex}` : undefined;
}
